import $ from 'jquery';
import { throttle } from 'lodash-es';
import themeCommon from './_common';
import {getElementOffset, getWindowScrollPos} from '../_util';

const baseClass = 'scroll-indicator';

class ScrollIndicator {
  constructor(el) {
    this.$el = $(el);
    this.$navigation = this.$el.find('.scroll-indicator__items');

    this._activeAnchorItem = null;

    this.anchors = [];

    $(window).on('scroll resize load', throttle(this.updateNavigation.bind(this), 1000 / 8));

    this.crawlAnchors();
    this.buildNavigation();

    if (this.anchors.length >= 2) {
      this.$el.addClass(`${baseClass}--loaded`);
    }
  }

  crawlAnchors() {
    const anchors = $("[data-scroll-indicator]");

    for (let i = 0; i < anchors.length; i++) {
      this.anchors.push({
        target: $(anchors[i]),
        navigationPoint: null,
      });
    }
  }

  buildNavigation() {
    const elementTemplate = "<li><button><span class=\"scroll-indicator__item-tooltip\">X</span></button></li>";

    this.$navigation.empty();

    for (let i = 0; i < this.anchors.length; i++) {
      const $navigationPoint = $(elementTemplate);

      $navigationPoint
        .find('.scroll-indicator__item-tooltip')
        .text(this.anchors[i].target.data('scroll-indicator'));

      $navigationPoint.on('click', 'button', () => themeCommon.smoothScrollTo(this.anchors[i].target, 750));

      this.$navigation.append($navigationPoint);

      this.anchors[i].navigationPoint = $navigationPoint;
    }
  }

  updateNavigation() {
    const winScrollPos = getWindowScrollPos();
    let lastPassedItem = -1;

    for (let i = 0; i < this.anchors.length; i++) {
      const anchor = this.anchors[i];

      const offset = getElementOffset(anchor.target[0]);
      if (Math.ceil(winScrollPos.top) >= Math.floor(offset.top)) {
        lastPassedItem = i;
      }
    }

    this.activeItem = lastPassedItem;
  }

  get activeItem() {
    return this._activeAnchorItem;
  }

  set activeItem(value) {
    if (this._activeAnchorItem === value) {
      return;
    }

    if (this._activeAnchorItem !== -1) {
      this.$navigation.find('li').removeClass('active');
    }

    this._activeAnchorItem = value;
    if (this.anchors[this._activeAnchorItem] != null) {
      this.anchors[this._activeAnchorItem].navigationPoint.addClass('active');
    }
  }
}

function init() {
  $(".scroll-indicator").each((i, el) => new ScrollIndicator(el));
}

export default {
  init
};
